<section class="container">
  <div class="text-container">
    <div class="title-footer">
      Available only to {{channelNames ?? ''}} subscribers
    </div>
    <div class="text-footer">
      To discuss pricing options please contact our sales team.
    </div>
  </div>
  <button class="button-primary" (click)="onClickRequest()">
    Request Access
  </button>
</section>
